/* El Ritual — mejora progresiva del menú móvil.
   Complementa el controlador existente: ARIA, foco, cierre seguro y fallback. */
(function () {
  'use strict';

  function initMobileNav() {
    var burger = document.getElementById('er-burger');
    var drawer = document.getElementById('er-mnav');
    var scrim = document.getElementById('er-scrim');
    var close = document.getElementById('er-mnav-x');
    if (!burger || !drawer || !scrim || !close) return;
    if (burger.dataset.erMobileEnhanced === '1') return;
    burger.dataset.erMobileEnhanced = '1';

    var lastTrigger = burger;

    function isOpen() {
      return drawer.dataset.open === '1';
    }

    function focusables() {
      return Array.prototype.slice.call(drawer.querySelectorAll(
        'a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'
      )).filter(function (el) {
        return el.getClientRects().length > 0 && el.getAttribute('aria-hidden') !== 'true';
      });
    }

    function sync(open, moveFocus) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      scrim.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        document.body.style.overflow = 'hidden';
        if (moveFocus) {
          window.requestAnimationFrame(function () {
            try { close.focus({ preventScroll: true }); } catch (e) { close.focus(); }
          });
        }
      }
    }

    function openFallback() {
      lastTrigger = document.activeElement || burger;
      drawer.dataset.open = '1';
      scrim.dataset.open = '1';
      sync(true, true);
    }

    function closeDrawer(returnFocus) {
      drawer.dataset.open = '0';
      scrim.dataset.open = '0';
      drawer.setAttribute('aria-hidden', 'true');
      scrim.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (returnFocus) {
        window.requestAnimationFrame(function () {
          var target = lastTrigger && document.contains(lastTrigger) ? lastTrigger : burger;
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
        });
      }
    }

    burger.addEventListener('click', function () {
      lastTrigger = burger;
      window.requestAnimationFrame(function () {
        if (!isOpen()) openFallback();
        else sync(true, true);
      });
    });

    close.addEventListener('click', function () {
      window.requestAnimationFrame(function () { closeDrawer(true); });
    });

    scrim.addEventListener('click', function () {
      window.requestAnimationFrame(function () { closeDrawer(true); });
    });

    drawer.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (link) closeDrawer(false);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) {
        event.preventDefault();
        drawer.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900 && isOpen()) closeDrawer(false);
    }, { passive: true });

    sync(isOpen(), false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }
  document.addEventListener('shopify:section:load', initMobileNav);
})();
